import { Button } from 'antd'

import { ContainerModal, Content } from './styles'
import DeleteApprovalModalHook from './DeleteSystemApprovalClaimModal.hook'

export default function DeleteSystemApprovalModal() {
  const {
    deleteClaimSystemApprovalModal,
    handleSetDeleteApprovalModal,
    onCancelModal,
    fullname,
    isPendingApproval,
  } = DeleteApprovalModalHook()

  return (
    <ContainerModal
      open={deleteClaimSystemApprovalModal.open}
      closable={false}
      width={350}
      onCancel={() => onCancelModal()}
      onOk={() => handleSetDeleteApprovalModal()}
      centered
      footer={[
        <Button onClick={onCancelModal} loading={isPendingApproval} disabled={isPendingApproval}>
          ยกเลิก
        </Button>,
        <Button
          type="primary"
          danger
          onClick={handleSetDeleteApprovalModal}
          loading={isPendingApproval}
          disabled={isPendingApproval}
        >
          ลบ
        </Button>,
      ]}
    >
      <b>คุณต้องการลบระดับอนุมัติ</b>
      <Content>
        คุณแน่ใจหรือไม่ที่จะทำการลบระดับอนุมัติ 
        <br />“{fullname}”
      </Content>
    </ContainerModal>
  )
}
